(() => {
  document.querySelectorAll('.landing-hero-product').forEach((root) => initHero(root));

  function initHero(root) {
    initGallery(root);
    initVariantPicker(root);
    initBundleTiers(root);
    syncFormState(root);
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    const slides = root.querySelectorAll('[data-gallery-main] [data-gallery-index]');
    const thumbs = root.querySelectorAll('[data-gallery-thumbs] [data-thumb-index]');
    if (!slides.length || !thumbs.length) return;

    const show = (i) => {
      slides.forEach(s => s.classList.toggle('is-active', +s.dataset.galleryIndex === i));
      thumbs.forEach(t => t.classList.toggle('is-active', +t.dataset.thumbIndex === i));
    };
    thumbs.forEach(t => {
      t.addEventListener('click', () => show(+t.dataset.thumbIndex));
    });
  }

  /* ---------- Variant picker (swatch / button / dropdown) ---------- */
  function initVariantPicker(root) {
    const variantsScript = root.querySelector('[data-product-variants]');
    if (!variantsScript) return;
    let variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch { return; }

    const variantInput = root.querySelector('[data-variant-id-input]');
    const priceEl = root.querySelector('[data-current-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const saveBadge = root.querySelector('[data-save-badge]');
    const atcButton = root.querySelector('[data-atc-button]');
    const atcLabel = root.querySelector('[data-atc-label]');

    // Collect option inputs grouped by index
    const inputs = root.querySelectorAll('[data-option-index]');
    if (!inputs.length) return;

    const optionsCount = Math.max(...Array.from(inputs).map(i => +i.dataset.optionIndex)) + 1;

    const getCurrentValues = () => {
      const result = new Array(optionsCount);
      // For radios, find checked. For selects, take .value
      Array.from(inputs).forEach((el) => {
        const idx = +el.dataset.optionIndex;
        if (el.tagName === 'SELECT') {
          result[idx] = el.value;
        } else if (el.type === 'radio' && el.checked) {
          result[idx] = el.value;
        }
      });
      return result;
    };

    const updateSelectedClasses = () => {
      // For each radio set, mark its parent label is-selected
      Array.from(inputs).forEach((el) => {
        if (el.type !== 'radio') return;
        const wrapper = el.closest('.landing-hero-product__swatch, .landing-hero-product__btn-pill');
        if (wrapper) {
          if (el.checked) wrapper.classList.add('is-selected');
          else wrapper.classList.remove('is-selected');
        }
      });
    };

    const update = () => {
      updateSelectedClasses();
      const chosen = getCurrentValues();

      chosen.forEach((val, idx) => {
        const lbl = root.querySelector(`[data-option-value="${idx}"]`);
        if (lbl && val) lbl.textContent = val;
      });

      const match = variants.find(v =>
        v.options.every((o, i) => o === chosen[i])
      );
      if (!match) return;

      if (variantInput) variantInput.value = match.id;
      root.dataset.variantId = match.id;
      root.dataset.variantPrice = match.price;

      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
          if (saveBadge) {
            const pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            saveBadge.textContent = `SAVE ${pct}%`;
            saveBadge.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (saveBadge) saveBadge.style.display = 'none';
        }
      }

      if (atcButton && atcLabel) {
        if (match.available) {
          atcButton.disabled = false;
          atcLabel.textContent = atcLabel.dataset.label || 'Add to Cart';
        } else {
          atcButton.disabled = true;
          atcLabel.textContent = 'Sold Out';
        }
      }

      refreshBundlePrices(root, match.price, match.compare_at_price);
    };

    inputs.forEach(el => el.addEventListener('change', update));
    updateSelectedClasses();
  }

  /* ---------- Bundle tiers ----------
     v1.4.8 — DOM mutation kaldırıldı (selected state CSS `input:checked + .tier-card` ile).
     Editor'da tamamen bypass: Shopify.designMode true ise JS hiç bind olmaz, scroll-restore stabil. */
  function initBundleTiers(root) {
    if (window.Shopify && window.Shopify.designMode) return;

    const radios = root.querySelectorAll('.landing-hero-product__tier-radio');
    const qtyInput = root.querySelector('[data-quantity-input]');
    if (!radios.length) return;

    const apply = (radio) => {
      // selected state CSS sibling selector ile, JS DOM mutation yok
      const qty = parseInt(radio.dataset.tierQty, 10) || 1;
      if (qtyInput) qtyInput.value = String(qty);

      const total = parseInt(radio.dataset.tierTotal, 10);
      const atcTotal = root.querySelector('[data-atc-total]');
      if (atcTotal && !isNaN(total)) {
        atcTotal.textContent = ' — ' + formatMoney(total);
      }

      // ---- Per-unit variant picker (F7-R2/T1) ----
      // Her radio change'de önce tüm kapsayıcılar sıfırlanır; sadece seçili
      // kademenin "variant_picker" açık olan kapsayıcısı doldurulup gösterilir.
      root.querySelectorAll('[data-unit-picks]').forEach((el) => {
        el.hidden = true;
        el.innerHTML = '';
      });

      const tierIdx = radio.dataset.tierIdx;
      if (tierIdx === undefined) return;
      const picksEl = root.querySelector(`[data-unit-picks][data-tier-idx="${tierIdx}"]`);
      if (!picksEl) return;
      if (radio.dataset.variantPicker === undefined) return; // kapsayıcı hidden kalır

      const variantsScript = root.querySelector('script[data-bundle-variants]');
      if (!variantsScript) return;
      let variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch {
        return; // bozuk JSON tüm bloğu çökertmesin
      }
      if (!Array.isArray(variants)) return;

      const availableVariants = variants.filter((v) => v.available === true);

      for (let i = 0; i < qty; i++) {
        const select = document.createElement('select');
        select.className = 'landing-hero-product__option-select';
        select.setAttribute('data-unit-index', String(i));
        select.required = true;

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Choose a variant';
        select.appendChild(placeholder);

        availableVariants.forEach((v) => {
          const opt = document.createElement('option');
          opt.value = String(v.id);
          opt.textContent = v.title;
          select.appendChild(opt);
        });

        picksEl.appendChild(select);
      }

      picksEl.hidden = false;
    };

    radios.forEach(r => r.addEventListener('change', () => apply(r)));

    const checked = Array.from(radios).find(r => r.checked);
    if (checked) apply(checked);
  }

  function refreshBundlePrices(root, unitPrice, unitCompare) {
    // F7-R1 fix (adversarial review caught it): this used to query
    // '.landing-hero-product__tier' (no such class exists — the actual card
    // is '.landing-hero-product__tier-card') and then look for the radio as
    // a DESCENDANT of that label, but the radio is a preceding SIBLING, not
    // a child. Both mistakes together meant this whole function silently
    // matched zero elements and never ran on any real page. Iterating the
    // radios directly (a class that does exist) and reaching the label via
    // nextElementSibling matches the actual markup.
    const radios = root.querySelectorAll('.landing-hero-product__tier-radio');
    const tiersEl = root.querySelector('.landing-hero-product__tiers');
    const savingsLabel = (tiersEl && tiersEl.dataset.savingsLabel) || 'Save';
    radios.forEach(radio => {
      const li = radio.nextElementSibling;
      if (!li) return;
      const qty = parseInt(radio.dataset.tierQty, 10) || 1;
      // velocco 2026-09-29 — kesirli yüzde (tier_N_discount_pct_exact) varsa fiyat onunla
      // hesaplanır; etikette yuvarlanmış yüzde gösterilir.
      const exactPct = parseFloat(radio.dataset.tierDiscountExact) || 0;
      const discountPct = exactPct > 0 ? Math.round(exactPct) : (parseInt(radio.dataset.tierDiscount, 10) || 0);
      const calcPct = exactPct > 0 ? exactPct : discountPct;
      // Per-tier, not block-wide: a legacy page with the old "Show amount +
      // percent" checkbox OFF could have different discount types per tier,
      // so the effective display mode is resolved per tier server-side too.
      const savingsDisplay = radio.dataset.savingsDisplay || 'both';

      const fullTotal = unitPrice * qty;
      const discountedTotal = fullTotal - Math.round(fullTotal * calcPct / 100);

      radio.dataset.tierTotal = String(discountedTotal);
      radio.dataset.tierTotalFull = String(fullTotal);

      const compareEl = li.querySelector('.landing-hero-product__tier-compare');
      const priceEl = li.querySelector('.landing-hero-product__tier-price');
      const savingsEl = li.querySelector('.landing-hero-product__tier-savings');

      if (priceEl) priceEl.textContent = formatMoney(discountedTotal);
      if (compareEl) {
        compareEl.textContent = discountPct > 0 ? formatMoney(fullTotal) : '';
        compareEl.style.display = discountPct > 0 ? '' : 'none';
      }
      if (savingsEl) {
        const saved = fullTotal - discountedTotal;
        if (saved > 0 && savingsDisplay !== 'none') {
          if (savingsDisplay === 'both') {
            savingsEl.textContent = `${savingsLabel} ${formatMoney(saved)} (${discountPct}% off)`;
          } else if (savingsDisplay === 'amount') {
            savingsEl.textContent = `${savingsLabel} ${formatMoney(saved)}`;
          } else {
            savingsEl.textContent = `${savingsLabel} ${discountPct}%`;
          }
          savingsEl.style.display = '';
        } else {
          savingsEl.textContent = '';
          savingsEl.style.display = 'none';
        }
      }

      // Update ATC total if this tier is currently selected
      if (radio.checked) {
        const atcTotal = root.querySelector('[data-atc-total]');
        if (atcTotal) atcTotal.textContent = ' — ' + formatMoney(discountedTotal);
      }
    });
  }

  /* ---------- Helpers ---------- */
  function syncFormState(root) {
    const form = root.querySelector('form');
    if (!form) return;
    // Ensure variant id stays in sync if user changes select after load
    form.addEventListener('submit', (e) => {
      const variantInput = root.querySelector('[data-variant-id-input]');
      if (variantInput && !variantInput.value) {
        e.preventDefault();
      }
    });
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    const value = cents / 100;
    const symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? '' : '$';
    // Use Intl when shop locale is available
    try {
      const locale = (window.Shopify && window.Shopify.locale) || 'en-AU';
      const code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(value);
    } catch {
      return symbol + value.toFixed(2);
    }
  }
})();
